export default __webpack_public_path__ + "static/media/contact.1c318e8a.svg";